export default {
  data: () => ({
    months: {
      1: 'Январь',
      2: 'Февраль',
      3: 'Март',
      4: 'Апрель',
      5: 'Май',
      6: 'Июнь',
      7: 'Июль',
      8: 'Август',
      9: 'Сентябрь',
      10: 'Октябрь',
      11: 'Ноябрь',
      12: 'Декабрь'
    }
  }),

  computed: {
    yours() {
      return this.createArray(new Date().getFullYear() - 1901)
    },

    days() {
      return this.createArray(31)
    }
  },

  methods: {
    createArray(count) {
      return [...Array(count)].map((e, i) => i + 1)
    }
  }
}
